import { MIME_TYPE_HEIC, MIME_TYPE_JPEG, MIME_TYPE_JPG, MIME_TYPE_PNG, MIME_TYPE_WEBP } from '../../constants';
import { pluralize } from '../../string';

/** Максимальное число изображений в поле медиа варианта */
export const MAX_PRODUCT_MEDIA_FIELD_IMAGE_COUNT = 30;
/** Максимальное число видео в поле медиа варианта */
export const MAX_PRODUCT_MEDIA_FIELD_VIDEO_COUNT = 1;

/** Максимальный размер одного изображения, МБ */
export const MAX_PRODUCT_MEDIA_FIELD_IMAGE_SIZE_MB = 35;

/** Максимальный размер одного изображения в байтах */
export const MAX_PRODUCT_MEDIA_FIELD_IMAGE_MAX_SIZE_IN_BYTES = MAX_PRODUCT_MEDIA_FIELD_IMAGE_SIZE_MB * 1024 * 1024;

/** Минимальная ширина изображения, пиксели */
export const MIN_PRODUCT_MEDIA_FIELD_IMAGE_WIDTH_PX = 500;

/** Минимальная высота изображения, пиксели */
export const MIN_PRODUCT_MEDIA_FIELD_IMAGE_HEIGHT_PX = 500;

export const PRODUCT_MEDIA_FIELD_IMAGE_MIME_TYPES = [
    MIME_TYPE_JPEG,
    MIME_TYPE_JPG,
    MIME_TYPE_PNG,
    MIME_TYPE_HEIC,
    MIME_TYPE_WEBP,
];

export const PRODUCT_MEDIA_FIELD_IMAGE_CAPTION = pluralize(
    MAX_PRODUCT_MEDIA_FIELD_IMAGE_COUNT,
    `До %d изображения, JPG, PNG, HEIC, WEBP, не более ${MAX_PRODUCT_MEDIA_FIELD_IMAGE_SIZE_MB} МБ каждое. Размер изображения — минимум ${MIN_PRODUCT_MEDIA_FIELD_IMAGE_WIDTH_PX}х${MIN_PRODUCT_MEDIA_FIELD_IMAGE_HEIGHT_PX}, рекомендуемое
соотношение сторон 3:4.`,
    `До %d изображений, JPG, PNG, HEIC, WEBP, не более ${MAX_PRODUCT_MEDIA_FIELD_IMAGE_SIZE_MB} МБ каждое. Размер изображения — минимум ${MIN_PRODUCT_MEDIA_FIELD_IMAGE_WIDTH_PX}х${MIN_PRODUCT_MEDIA_FIELD_IMAGE_HEIGHT_PX}, рекомендуемое
соотношение сторон 3:4.`,
    `До %d изображений, JPG, PNG, HEIC, WEBP, не более ${MAX_PRODUCT_MEDIA_FIELD_IMAGE_SIZE_MB} МБ каждое. Размер изображения — минимум ${MIN_PRODUCT_MEDIA_FIELD_IMAGE_WIDTH_PX}х${MIN_PRODUCT_MEDIA_FIELD_IMAGE_HEIGHT_PX}, рекомендуемое
соотношение сторон 3:4.`
);
